import { persons } from "@/mocks/homeData";
import SectionHead from "./SectionHead";

export default function PersonRoundup() {
  return (
    <section id="renwu" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <SectionHead
          kicker="人物侧写档案"
          title="人物盘点 · 反复被点名的那些人"
          desc="把散落在不同事件里的同一位主角归档到一起。这里以角色与公众形象代称梳理公开信息，不做道德审判，只做一场冷静的侧写。"
          action="查看人物图鉴"
        />

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3 md:mt-12">
          {persons.map((p) => (
            <article
              key={p.name}
              className="group flex flex-col gap-4 rounded-xl border border-background-200 bg-background-100 p-4 transition-colors hover:border-background-300 md:p-5"
            >
              <div className="flex items-center gap-4">
                <a href="#" className="block shrink-0 overflow-hidden rounded-full ring-2 ring-background-200 transition-colors group-hover:ring-primary-300">
                  <img src={p.image} alt={p.name} title={`${p.name} - 嘿料吃瓜人物盘点`} className="h-16 w-16 object-cover object-top md:h-20 md:w-20" />
                </a>
                <div className="min-w-0 flex-1">
                  <span className="inline-block rounded bg-secondary-200 px-2 py-0.5 text-[11px] font-bold text-secondary-900">{p.role}</span>
                  <h3 className="mt-1.5 truncate font-heading text-base font-black text-foreground-950">
                    <a href="#" className="hover:text-primary-600">
                      {p.name}
                    </a>
                  </h3>
                </div>
              </div>

              <p className="line-clamp-2 min-h-[40px] text-sm leading-relaxed text-foreground-600">{p.line}</p>

              <div className="flex items-center justify-between border-t border-background-200 pt-3">
                <div className="flex items-center gap-4 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-file-text-line" />
                    </span>
                    {p.files} 档案
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-fire-line" />
                    </span>
                    上榜 {p.onList}
                  </span>
                </div>
                <a href="#" className="inline-flex items-center gap-1 whitespace-nowrap text-xs font-bold text-primary-600 hover:text-primary-700">
                  看档案
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-arrow-right-s-line" />
                  </span>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}